var _path, _path2, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg22(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.665 9.16878L16 10.0001V23.3334L16.3633 22.6976C17.7876 20.205 20.4384 18.6667 23.3092 18.6667H29.3333C30.0697 18.6667 30.6667 18.0698 30.6667 17.3334V6.66675H21.8708C19.8456 6.66675 17.9302 7.58735 16.665 9.16878Z",
    fill: "url(#paint0_linear_887_4802)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M15.335 9.16878L16 10.0001V23.3334L15.6367 22.6976C14.2124 20.205 11.5616 18.6667 8.69073 18.6667H1.33331V6.66675H10.1292C12.1544 6.66675 14.0698 7.58735 15.335 9.16878Z",
    fill: "#FAB215"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.69079 18.6668H1.33337V24.0002H8.52597C11.5294 24.0002 14.3341 25.5012 16 28.0002C17.666 25.5012 20.4707 24.0002 23.4741 24.0002H26.6667C28.8758 24.0002 30.6667 22.2091 30.6667 20V17.3335C30 18.0002 29.3334 18.6668 28 18.6668H23.3093C20.4384 18.6668 17.7877 20.2051 16.3633 22.6977L16 23.3335L15.6367 22.6977C14.2124 20.2051 11.5616 18.6668 8.69079 18.6668Z",
    fill: "#FAB215"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_887_4802",
    x1: 30.6667,
    y1: 13.3334,
    x2: 16,
    y2: 13.3334,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAB215",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB215",
    stopOpacity: 0.4
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg22);
export default __webpack_public_path__ + "static/media/22.b744bbb8fc3fe664d2584657245b7ae2.svg";
export { ForwardRef as ReactComponent };